import { BillingCode, BILLING_CODES_REQUIRED_MESSAGE } from 'src/participantHistory/intakeNote/billingCodeConstants'
import { z } from 'zod'

const MAX_INPUT_LENGTH = 3000

const BILLING_CODES_SCHEMA = z.array(z.enum(Object.values(BillingCode) as [string, ...string[]]))

export const TREATMENT_PLAN_FORM_SCHEMA = z.object({
  presentingProblem: z.string().max(MAX_INPUT_LENGTH),
  treatmentGoals: z.string().max(MAX_INPUT_LENGTH),
  billingCodes: BILLING_CODES_SCHEMA,
  interventionsAndEngagementPlan: z.object({
    participateTreatmentProgram: z.boolean(),
    followupTelehealthSessions: z.boolean(),
    utilizeCommunicationChannels: z.boolean(),
    participantAgreement: z.boolean(),
    additionalResources: z.string().max(MAX_INPUT_LENGTH).optional(),
    coordinationWithExternalProviders: z.string().max(MAX_INPUT_LENGTH).optional(),
    other: z.string().max(MAX_INPUT_LENGTH).optional(),
  }),
  obstaclesAndActionPlan: z.string().max(MAX_INPUT_LENGTH),
})

export type TreatmentPlanFormType = z.infer<typeof TREATMENT_PLAN_FORM_SCHEMA>

/**
 * Diagnosis codes are a hard requirement, because billing cannot generate a claim without one.
 * Self-pay participants are exempt (there is no claim to generate) and get a confirmation dialog
 * instead of a validation error.
 */
export const createTreatmentPlanFormSchema = ({ requireBillingCodes = false } = {}) =>
  requireBillingCodes
    ? TREATMENT_PLAN_FORM_SCHEMA.extend({
        billingCodes: BILLING_CODES_SCHEMA.min(1, BILLING_CODES_REQUIRED_MESSAGE),
      })
    : TREATMENT_PLAN_FORM_SCHEMA
